import http from '@/utils/http'

// URL and endpoint constants
const API_URL = process.env.API_BASE_URL

const getListaItensGlossario = () => {
  const SUBJECT_LIST_URL = API_URL + 'glossario'
  let config = {
    method: 'get',
    url: SUBJECT_LIST_URL,
    responseType: 'json',
    credentials: true
  }
  return http(config)
}

const criarItemGlossario = (body) => {
  let config = {
    method: 'post',
    url: API_URL + 'glossario',
    responseType: 'json',
    credentials: true,
    body: body
  }
  return http(config)
}

const editarItemGlossario = (idItemGlossario, body) => {
  let config = {
    method: 'patch',
    url: API_URL + `glossario/${idItemGlossario}`,
    responseType: 'json',
    credentials: true,
    body: body
  }
  return http(config)
}

const excluirItemGlossario = (idItemGlossario) => {
  let config = {
    method: 'delete',
    url: API_URL + `glossario/${idItemGlossario}`,
    responseType: 'json',
    credentials: true
  }
  return http(config)
}

const alteraPropriedadeTipoDocumental = (idTipoDocumento, propriedade) => {
  let config = {
    method: 'patch',
    url: API_URL + `tipos-documentos/${idTipoDocumento}`,
    responseType: 'json',
    credentials: true,
    body: propriedade
  }
  return http(config)
}

const buscaTodosTiposDocumento = () => {
  const DOCUMENT_TYPES_URL = API_URL + 'tipos-documentos?todosTipos=true&incluirInativos=true'
  let config = {
    method: 'get',
    url: DOCUMENT_TYPES_URL,
    responseType: 'json',
    credentials: true
  }
  return http(config)
}

export default {
  getListaItensGlossario,
  criarItemGlossario,
  editarItemGlossario,
  excluirItemGlossario,
  alteraPropriedadeTipoDocumental,
  buscaTodosTiposDocumento
}
